import gql from "graphql-tag";

const getListVehicleType = gql`
  query($query: String, $limit: Int, $page: Int) {
    getListVehicleType(query: $query, paging: { limit: $limit, page: $page }) {
      id
      model
      updatedAt
      createdAt
    }
  }
`;

export default { getListVehicleType };
